import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

function parseThreeGLoadFromDom(): string {
  const extractFromRoot = (root: ParentNode): string => {
    const loadNumInput = root.querySelector<HTMLInputElement>('#loadNum');
    const loadNumFromInput = loadNumInput?.value?.trim() ?? '';
    if (loadNumFromInput) {
      return loadNumFromInput;
    }

    const loadNumSpan = root.querySelector('[data-domain-id="loadNum"]');
    const loadNumFromSpan = loadNumSpan?.textContent?.trim() ?? '';
    if (loadNumFromSpan) {
      return loadNumFromSpan;
    }

    const loadNumTitle = root.querySelector('.loadNum_Title');
    const loadNumFromTitle = loadNumTitle?.textContent?.trim() ?? '';
    if (loadNumFromTitle) {
      return loadNumFromTitle;
    }

    const loadIdInput = root.querySelector<HTMLInputElement>('#loadId');
    return loadIdInput?.value?.trim() ?? '';
  };

  const idFromTopDocument = extractFromRoot(document);
  if (idFromTopDocument) {
    return idFromTopDocument;
  }

  const frames = Array.from(document.querySelectorAll('iframe'));
  for (const frame of frames) {
    try {
      const frameDoc = frame.contentDocument;
      if (!frameDoc) {
        continue;
      }

      const idFromFrame = extractFromRoot(frameDoc);
      if (idFromFrame) {
        return idFromFrame;
      }
    } catch {
      // Ignore cross-origin frames.
    }
  }

  return '';
}

export class ThreeG implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return '';
      case 'freightTrackingID':
        return 'Load ID';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    return parseThreeGLoadFromDom();
  }

  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    const url = this.getCurrentUrl();
    return url.includes('3gtms.com');
  }
}
